
import './LeadrOrder.scss'
import ItemDetail from "./ItemDetail";
import OrderDetail from './OrderDetail';
import AttachmentLink from './ItemDetail/AttachmentLink';

const LeaderOrder = (props : any) => {
    return (
    <div className="LeaderOrder mt-1 p-3">
      <div>
        <div className="blueLabel pull-left">Order Details</div>
        {!props?.isBulkOrder && <div className='pull-right'>
          <AttachmentLink
             item={props.orderByIdValue}
             index={props.index}
             itemLevel = {"Order"}
          />
        </div>  } 
      </div>   
      <OrderDetail/>
      <ItemDetail requestReasonDetailData={props?.requestReasonDetailData} isBulkOrder={props.isBulkOrder}/>
    </div>
)}

export default LeaderOrder;